<template>
  <div class="qrcode-body" v-if="detail.name">
    <div class="qrcode-item">
      名称：
      <span>{{ detail.name }}</span>
    </div>
    <div class="qrcode-item">
      兑换码：
      <span>{{ detail.code }}</span>
    </div>
    <div class="qrcode-item">
      状态：
      <span :class="'qrcode-state-' + (detail.state || 0)">
        {{ detail.state === 1 ? "已兑换" : "未兑换" }}
      </span>
    </div>

    <div class="qrcode-btn" v-if="detail.state !== 1" @click="handleExchange">
      立即兑换
    </div>
  </div>
</template>

<script>
import COVER from '@/utils/COVER'
import DialogComponent from '@/components/Dialog'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'qrcode',
  data() {
    return {
      aid: '',
      cid: '',
      code: '',
      detail: {},
    }
  },
  props: ['activityData'],
  computed: {
    ...mapState(['dialogData']),
  },
  components: {
    DialogComponent
  },
  created() {
    const aid = this.$route.query.id || '';
    const cid = this.$route.query.cid || '';
    const code = this.$route.query.code || '';
    this.aid = aid;
    this.cid = cid;
    this.code = code;
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      COVER.$get('/coupon/show?aid=' + this.aid + '&cid=' + this.cid + '&code=' + this.code, {}).then(res => {
        if (res.errno === 0) {
          this.detail = res.data;
        }
      })
    },
    async handleExchange() {
      const res = window.prompt('请输入商户号', '');

      if (res === '620300') {
        COVER.$get('/coupon/verify?aid=' + this.aid + '&cid=' + this.cid + '&code=' + this.code, {}).then(res => {
          if (res.errno === 0) {
            this.getDetail();
            alert('兑换成功');
          }
        });

        return;
      }

      alert('商户号错误');
    }
  }

}

</script>

<style lang="less" scoped>
.qrcode-body {
  width: 90%;
  margin: 0 auto;
  padding: 3vh 0;
  color: #333;
  font-size: 4vw;
  display: flex;
  flex-direction: column;
  .qrcode-item {
    margin-bottom: 4vw;
  }
  .qrcode-btn {
    margin: 10vw auto;
    width: 70%;
    background: #1890ff;
    color: white;
    line-height: 3em;
    font-size: 3.6vw;
    text-align: center;
    border-radius: 4px;
  }
  .qrcode-state-0 {
    color: #87d068;
  }
  .qrcode-state-1 {
    color: #ff4d4f;
  }
}
</style>